let cached = null;

const webglAvailable = () => {
  if (cached !== null) return cached;
  try {
    const canvas = document.createElement('canvas');
    cached = Boolean(
      canvas.getContext('webgl')
      || canvas.getContext('experimental-webgl'),
    );
  } catch {
    cached = false;
  }
  return cached;
};

export default webglAvailable;
